import React, { useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { getDocumentById, resetDocument } from '../../../ducks/document';
import Loader from '../../../components/ui/Loader';
import PdfViewer from '../../../components/ui/PdfViewer';
import { MIME_TYPES, ALERT_TYPE } from '../../../constants';
import styles from './ViewDocumentModal.module.scss';
import FileViewer from '../../../components/ui/FileViewer';
import messages from '../../../utils/helper/messages';
import { AlertContext } from '../../../context/AlertContext';


const ViewDocumentModal = ({ document, show, onCancel }) => {
    const dispatch = useDispatch();
    const { showAlert } = useContext(AlertContext);

    const currentUser = useSelector((state) => state.user.currentUser);
    const currentDocument = useSelector(
        (state) => state.document.currentDocument
    );

    const [file, setFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleSuccess = () => {
        setIsLoading(false);
    };

    const handleClose = () => {
        dispatch(resetDocument());
        setIsLoading(false);
        setFile(null);
        onCancel();
    };

    const renderDocument = () => {
        switch (currentDocument?.contentType) {
            case MIME_TYPES.PDF:
                return <PdfViewer file={file} />;
            case MIME_TYPES.JPEG:
                return (
                    <div
                        className={`${styles.imageWrap} border border-1 bg-light rounded overflow-hidden`}>
                        <img
                            src={file}
                            alt={document.description}
                        />
                    </div>
                );
            case MIME_TYPES.DOCX:
            case MIME_TYPES.PPTX:
            case MIME_TYPES.XLSX:
                return (
                    <FileViewer
                        file={currentDocument.documentFile}
                        fileName={document.fileName}
                        type={document.format}
                    />
                );
        }
    };

    useEffect(() => {
        if (document) {
            setIsLoading(true);
            dispatch(
                getDocumentById(
                    currentUser?.companyId,
                    document.id,
                    handleSuccess, (error) => {
                        setIsLoading(false);
                        showAlert(`${messages.error.prefix} ${error}`, ALERT_TYPE.ERROR);
                    }
                )
            );
        }
    }, [document]);

    useEffect(() => {
        if (currentDocument) {
            setFile(currentDocument.documentFile);
        }
    }, [currentDocument]);

    return (
        <Modal
            size="lg"
            show={show}
            onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>View Document</Modal.Title>
            </Modal.Header>
            <Modal.Body className={styles.modalBody}>
                <div className="h-100 d-flex align-items-center justify-content-center">
                    {isLoading ? <Loader /> : renderDocument()}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ViewDocumentModal;
